import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Twitter, Send, MessageCircle, Mail, ArrowRight, TrendingUp } from 'lucide-react';
import './Community.css';

const Community = () => {
  const [email, setEmail] = useState('');
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`Thank you for joining! We'll contact you at ${email}`);
    setEmail('');
  };

  const socialLinks = [
    { icon: <Twitter size={28} />, name: 'Twitter', handle: '@nomoex_global', url: 'https://x.com/nomoex_global' },
    { icon: <Send size={28} />, name: 'Telegram', handle: 't.me/nomoexcommunity', url: 'https://t.me/nomoexcommunity' },
    { icon: <MessageCircle size={28} />, name: 'Discord', handle: 'discord.com/invite/W4R2aRY5', url: 'https://discord.com/invite/W4R2aRY5' },
    { icon: <TrendingUp size={28} />, name: 'CoinMarketCap', handle: 'View Price & Charts', url: 'https://coinmarketcap.com/currencies/nomoex/' },
  ];

  return (
    <section id="community" className="community-alien" data-testid="community-section" ref={ref}>
      <div className="section-container">
        <motion.div
          className="section-header-alien"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <div className="section-tag">
            <div className="tag-line"></div>
            <span className="tag-text">JOIN THE ECOSYSTEM</span>
            <div className="tag-line"></div>
          </div>
          <h2 className="section-title-alien">
            <span className="title-normal">COMMUNITY &</span>
            <span className="title-highlight">NETWORK</span>
          </h2>
          <p className="section-subtitle-alien">
            Connect with builders, validators, and innovators shaping the future of decentralized finance
          </p>
        </motion.div>

        <div className="community-grid">
          {/* Waitlist Form */}
          <motion.div
            className="waitlist-container"
            initial={{ opacity: 0, x: -30 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6 }}
          >
            <div className="waitlist-icon-wrapper">
              <Mail size={48} className="waitlist-icon" />
            </div>
            <h3 className="waitlist-title">Join Early Access Program</h3>
            <p className="waitlist-description">
              Get exclusive access to testnet, developer grants, and community rewards. Be among the first to build on Nomoex Chain.
            </p>
            <form onSubmit={handleSubmit} className="waitlist-form" data-testid="waitlist-form">
              <div className="form-wrapper">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email address"
                  required
                  className="email-input-alien"
                  data-testid="email-input"
                />
                <button type="submit" className="submit-btn-alien" data-testid="submit-btn">
                  <span>Join Waitlist</span>
                  <ArrowRight size={20} />
                </button>
              </div>
            </form>
          </motion.div>

          {/* Social Links */}
          <motion.div
            className="social-grid-alien"
            initial={{ opacity: 0, x: 30 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h3 className="social-title">Connect With Us</h3>
            {socialLinks.map((social, index) => (
              <motion.a
                key={index}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="social-card-alien"
                whileHover={{ x: 10, scale: 1.02 }}
                data-testid={`social-card-${index}`}
              >
                <div className="social-icon-alien">{social.icon}</div>
                <div className="social-info">
                  <div className="social-name">{social.name}</div>
                  <div className="social-handle">{social.handle}</div>
                </div>
                <ArrowRight size={20} className="social-arrow" />
              </motion.a>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Community;